import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Multiselect from 'vue-multiselect'
import VueScrollactive from 'vue-scrollactive'
import TransitionExpand from 'vue-transition-expand'
import Vuelidate from 'vuelidate'
import vClickOutside from 'v-click-outside'
import {VTooltip} from 'v-tooltip'
import ApplicationForm from 'cms-components/application-form.vue'
import AutoSwiper from 'cms-components/auto-swiper.vue'
import Blocks from 'cms-components/blocks.vue'
import ContactAnchorButton from 'cms-components/contact-anchor-button.vue'
import DownloadCatalogButton from 'cms-components/download-catalog-button.vue'
import Downloads from 'cms-components/downloads.vue'
import HeroTextMedia from 'cms-components/hero-text-media.vue'
import ImageCarouselForProductBe from 'cms-components/image-carousel-for-product-be.vue'
import ImageCarouselForProduct from 'cms-components/image-carousel-for-product.vue'
import ImageCarousel from 'cms-components/image-carousel.vue'
import QuotationRequest from 'cms-components/quotation-request.vue'
import ShoppingCartBe from 'cms-components/shopping-cart-be.vue'
import ShoppingCart from 'cms-components/shopping-cart.vue'
import SortAndSizeDropdowns from 'cms-components/sort-and-size-dropdowns.vue'
import AddToCartButton from 'components/add-to-cart-button.vue'
import BackButton from 'components/back-button.vue'
import BlockItems from 'components/block-items.vue'
import CategoryNavigation from 'components/category-navigation.vue'
import ConfirmationPopup from 'components/confirmation-popup.vue'
import ContactPersonSearch from 'components/contact-person-search.vue'
import DescriptionText from 'components/description-text.vue'
import DownloadItem from 'components/download-item.vue'
import DownloadList from 'components/download-list.vue'
import Dropdown from 'components/dropdown.vue'
import ExpandItem from 'components/expand-item.vue'
import Filters from 'components/filters.vue'
import FooterProducts from 'components/footer-products.vue'
import GenericForm from 'components/generic-form.vue'
import HighlightCarousel from 'components/highlight-carousel.vue'
import NewsletterForm from 'components/newsletter-form.vue'
import Notifications from 'components/notifications.vue'
import OverviewWithFilters from 'components/overview-with-filters.vue'
import ProductCarousel from 'components/product-carousel.vue'
import ProductCategoriesDropdownItems from 'components/product-categories-dropdown-items.vue'
import ProductDetail from 'components/product-detail.vue'
import ProductFilter from 'components/product-filter.vue'
import ProductSpecificationsBe from 'components/product-specifications-be.vue'
import ProductSpecifications from 'components/product-specifications.vue'
import Product from 'components/product.vue'
import RequestDownloadForm from 'components/request-download-form.vue'
import SearchBar from 'components/search-bar.vue'
import SearchTitle from 'components/search-title.vue'
import ShoppingCartItemsCount from 'components/shopping-cart-items-count.vue'
import ShoppingCartMenuButton from 'components/shopping-cart-menu-button.vue'
import SideMenu from 'components/side-menu.vue'
import SubcategoriesItems from 'components/subcategories-items.vue'
import ThemeCategories from 'components/theme-categories.vue'
import UploadField from 'components/upload-field.vue'
import VariantTable from 'components/variant-table.vue'
import YoutubeVideo from 'components/youtube-video.vue'
import { DEFAULT_SWIPER_OPTIONS, DEFAULT_SWIPER_WITH_AUTOPLAY_OPTIONS, PHONE_WIDTH, TABLET_PORTRAIT_WIDTH , addStar } from 'helpers/constants'
import Mixin from 'helpers/mixin'
import store from './store'
import 'styles/default.scss'
import 'vue-transition-expand/dist/vue-transition-expand.css'
import 'swiper/css/swiper.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.directive('tooltip', VTooltip)

Vue.component('AutoSwiper', AutoSwiper)
Vue.component('Blocks', Blocks)
Vue.component('BlockItems', BlockItems)
Vue.component('SubcategoriesItems', SubcategoriesItems)
Vue.component('ProductCategoriesDropdownItems', ProductCategoriesDropdownItems)
Vue.component('Downloads', Downloads)
Vue.component('Dropdown', Dropdown)
Vue.component('HeroTextMedia', HeroTextMedia)
Vue.component('HighlightCarousel', HighlightCarousel)
Vue.component('ProductCarousel', ProductCarousel)
Vue.component('ImageCarousel', ImageCarousel)
Vue.component('ImageCarouselForProduct', ImageCarouselForProduct)
Vue.component('ImageCarouselForProductBe', ImageCarouselForProductBe)
Vue.component('QuotationRequest', QuotationRequest)
Vue.component('ApplicationForm', ApplicationForm)
Vue.component('Notifications', Notifications)
Vue.component('OverviewWithFilters', OverviewWithFilters)
Vue.component('RequestDownloadForm', RequestDownloadForm)
Vue.component('NewsletterForm', NewsletterForm)
Vue.component('GenericForm', GenericForm)
Vue.component('SideMenu', SideMenu)
Vue.component('YoutubeVideo', YoutubeVideo)
Vue.component('BackButton', BackButton)
Vue.component('multiselect', Multiselect)
Vue.component('ContactPersonSearch', ContactPersonSearch)
Vue.component('ContactAnchorButton', ContactAnchorButton)
Vue.component('DownloadCatalogButton', DownloadCatalogButton)
Vue.component('AddToCartButton', AddToCartButton)
Vue.component('SortAndSizeDropdowns', SortAndSizeDropdowns)
Vue.component('VariantTable', VariantTable)
Vue.component('SearchBar', SearchBar)
Vue.component('SearchTitle', SearchTitle)
Vue.component('ExpandItem', ExpandItem)
Vue.component('ShoppingCart', ShoppingCart)
Vue.component('ShoppingCartBe', ShoppingCartBe)
Vue.component('ShoppingCartItemsCount', ShoppingCartItemsCount)
Vue.component('ShoppingCartMenuButton', ShoppingCartMenuButton)
Vue.component('DescriptionText', DescriptionText)
Vue.component('DownloadItem', DownloadItem)
Vue.component('DownloadList', DownloadList)
Vue.component('ProductDetail', ProductDetail)
Vue.component('ProductSpecifications', ProductSpecifications)
Vue.component('ProductSpecificationsBe', ProductSpecificationsBe)
Vue.component('CategoryNavigation', CategoryNavigation)
Vue.component('UploadField', UploadField)
Vue.component('ConfirmationPopup', ConfirmationPopup)
Vue.component('Filters', Filters)
Vue.component('Product', Product)
Vue.component('ProductFilter', ProductFilter)
Vue.component('FooterProducts', FooterProducts)
Vue.component('ThemeCategories', ThemeCategories)

Vue.use(vClickOutside)
Vue.use(TransitionExpand)
Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollactive)
Vue.use(Vuelidate)

// filter to get a cms translation defined in store-data.liquid
type ChildTranslationKey = keyof ILanguageDropdown
// for now only languageDropdown is an object
Vue.filter('t', (key: keyof ITranslations | ChildTranslationKey, parentKey?: 'languageDropdown'): string => {
  if (parentKey) return window.TRANSLATIONS[parentKey]?.[key as ChildTranslationKey] || key
  const value = window.TRANSLATIONS[key as keyof ITranslations]
  return typeof value === 'string' ? value : key
})

Vue.filter('required', addStar)

new Vue({
  name: 'App',
  store,

  mixins: [Mixin],

  data() {
    return {
      headerMenusOpen: [],
      defaultSwiperOptions: DEFAULT_SWIPER_OPTIONS,
      defaultSwiperWithAutoplayOptions: DEFAULT_SWIPER_WITH_AUTOPLAY_OPTIONS,
      headerHeight: 0,
      headerIsSticky: false,
      showSearchInput: true,
      scrollTimeout: false,
      lastKnownScrollPosY: 0
    }
  },

  computed: {
    showGrayOverlayBelowHeader(): boolean {
      return this.headerMenusOpen.some((open: boolean) => open)
    },

    // returns url without query string and hash
    currentUrl(): string {
      const currentUrl = `${location.origin}${location.pathname}`
      // remove trailing slash
      return currentUrl.replace(/\/+$/, '').toLowerCase()
    }
  },

  watch: {
    headerIsSticky(): void {
      // timeout because of transition
      this.$nextTick(() => setTimeout(() => this.setHeaderHeight(), 310))
    },
    showSearchInput(): void {
      // timeout because of transition
      this.$nextTick(() => setTimeout(() => this.setHeaderHeight(), 310))
    }
  },

  created(): void {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.onResize)
    store.dispatch('mobileMenu/addTouchEvents')
  },

  mounted(): void {
    this.$nextTick(() => this.setHeaderHeight())
  },

  methods: {
    onResize(): void {
      this.setHeaderHeight()

      if (window.innerWidth > TABLET_PORTRAIT_WIDTH && this.$store.state.mobileMenu.isOpen) {
        this.$store.commit('mobileMenu/close')
      }

      if (window.innerWidth > PHONE_WIDTH && !this.showSearchInput) this.showSearchInput = true

      // close overlay and header menus
      if (window.innerWidth <= TABLET_PORTRAIT_WIDTH && this.headerMenusOpen.some((open: boolean) => open))
        this.headerMenusOpen = []
    },

    onScroll(): void {
      if (this.headerIsSticky && window.pageYOffset === 0) this.headerIsSticky = false
      else if (!this.headerIsSticky && window.pageYOffset > 0) this.headerIsSticky = true

      // show and hide search bar
      if (!this.scrollTimeout) {
        if (window.innerWidth <= PHONE_WIDTH) {
          const searchInput = this.$refs.searchInput as HTMLElement
          const offset = searchInput?.clientHeight || 0

          if (!this.showSearchInput && window.pageYOffset < this.lastKnownScrollPosY) {
            this.scrollTimeout = true
            this.showSearchInput = true
            setTimeout(() => (this.scrollTimeout = false), 500)
          } else if (
            this.showSearchInput &&
            window.pageYOffset > offset &&
            window.pageYOffset > this.lastKnownScrollPosY
          ) {
            this.scrollTimeout = true
            this.showSearchInput = false
            setTimeout(() => (this.scrollTimeout = false), 500)
          }
        } else {
          if (!this.showSearchInput) this.showSearchInput = true
        }
      }

      this.lastKnownScrollPosY = window.pageYOffset
    },

    isActiveDivision(url: string): boolean {
      return this.currentUrl.indexOf(url.toLowerCase()) === 0
    },

    isActiveUrl(url: string): boolean {
      return this.currentUrl === url.toLowerCase()
    },

    isActiveRelativeUrl(url: string): boolean {
      // remove trailing slash
      const currentRelativeUrl = `${location.pathname}`.replace(/\/+$/, '').toLowerCase()
      return currentRelativeUrl === url.toLowerCase()
    },

    isActiveOrParentPage(url: string): boolean {
      // returns true when url is current url or is parent page
      const urlPieces = url
        .toLowerCase()
        .split('/')
        .filter(urlPiece => urlPiece.length > 0)
      const currentUrlPieces = this.currentUrl.split('/').filter(urlPiece => urlPiece.length > 0)

      if (urlPieces.length === 0) return false

      for (let i = 0; i < urlPieces.length; i++) {
        const index = currentUrlPieces.indexOf(urlPieces[i])

        if (index < 0) return false
        if (i > 0) {
          // after the first one check if the foundindex is one more than the previous one
          const prevIndex = currentUrlPieces.indexOf(urlPieces[i - 1])
          if (prevIndex + 1 !== index) return false
        }
      }
      return true
    },

    setHeaderHeight(): void {
      const header = document.querySelector('.sticky-header')
      if (!header) return
      this.headerHeight = header.clientHeight
    },

    showSocial(socialLink: ISocialLink, socialsToShow: string[]): boolean {
      return socialsToShow.some(social => socialLink.url.includes(social.toLowerCase()))
    }
  }
}).$mount('#app')
